import { render } from "./ViewLogin.vue?vue&type=template&id=2c7c1b8d"
import script from "./ViewLogin.vue?vue&type=script&lang=js"
export * from "./ViewLogin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__